import { Store } from 'vuex';
import { AlertLevelType } from '@/shared/config/store/alert-store';

export default class JhiAlertService {
  private store: Store<{}>;

  constructor(store: Store<{}>) {
    this.store = store;
    this.store.commit('initAlert');
  }

  private showAlert(message: string, type = AlertLevelType.INFO) {
    this.store.commit('setAlertMessage', { message, type });
  }

  public countDownChanged(dismissCountDown: number) {
    this.store.commit('countDownChanged', dismissCountDown);
  }

  public watchAlert(alertMessageFunction) {
    this.store.watch(this.store.getters.getAlertMessage, alertMessage => {
      alertMessageFunction(alertMessage);
    });
  }

  public showError(message: string) {
    this.showAlert(message, AlertLevelType.ERROR);
  }
}
